import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Vendor from "interfaces/Vendor";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Vendor;
}

export default class View extends React.Component<RouteComponentProps<RouteParams>, State> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {
                id: 0,
                vendorNo: "",
                name: ""
            },
        }
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink to="/vendors">Vendors</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>{this.state.data.name}</BreadcrumbLink>
                </Breadcrumb>
                {this.state.errorMessage && (
                    <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                )}
                <h3 className="card__title">{this.state.data.name}</h3>
                <div className="box">
                    <div className="full-width">
                        <div className="field-group">
                            <span className="field-label">ID</span>
                            <span className="field-item">{this.state.data.id}</span>
                        </div>
                        <div className="field-group">
                            <span className="field-label">Vendor Number</span>
                            <span className="field-item">{this.state.data.vendorNo}</span>
                        </div>
                        <div className="field-group">
                            <span className="field-label">Name</span>
                            <span className="field-item">{this.state.data.name}</span>
                        </div>
                        <div className="field-group">
                            <span className="field-label">Description</span>
                            <span className="field-item">{this.state.data.description}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch("vendors/" + this.props.match.params.id, undefined, true);
            if (response.ok) {
                let data = await response.json() as Vendor;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${this.state.data.name} - Vendor - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/vendors/View.tsx